import { ReactElement } from 'react';
import { Breadcrumb, Heading, Page } from 'components';
import { Button, Card } from '@ff-it/ui';
import { Route, Routes } from 'react-router';
import { Link } from 'react-router-dom';

import { NewCompany } from './NewCompany';
import { NewOutletOrServiceCategory } from './NewOutletOrServiceCategory';
import { NewClient } from './NewClient';

function Categories(): ReactElement {
  return (
    <>
      <Heading title="Create a ticket" />
      <div className="row">
        <div className="col-md-3">
          <Card>
            <p className="card-text">New company credentials</p>
            <Button variant="primary" asChild>
              <Link to="new_company">New company</Link>
            </Button>
          </Card>
        </div>
        <div className="col-md-3">
          <Card>
            <p>New outlet or service category for existing provider&apos;s company credentials</p>
            <Button variant="primary" asChild>
              <Link to="new_outlet_or_service_category"> New outlet or service category</Link>
            </Button>
          </Card>
        </div>
        <div className="col-md-3">
          <Card>
            <p>New client or agreement for existing company credentials</p>
            <Button variant="primary" asChild>
              <Link to="new_client">New client</Link>
            </Button>
          </Card>
        </div>
      </div>
    </>
  );
}

export function SubmitTicket(): ReactElement {
  return (
    <Page>
      <Breadcrumb>Support</Breadcrumb>
      <Routes>
        <Route index element={<Categories />} />
        <Route path="new_company" element={<NewCompany />} />
        <Route path="new_outlet_or_service_category" element={<NewOutletOrServiceCategory />} />
        <Route path="new_client" element={<NewClient />} />
      </Routes>
    </Page>
  );
}
